// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb9133aa","667":"41e136d5"}[chunkId] + ".chunk.js";
};